/**
 * @generated SignedSource<<18ff91e30261fdb34abd4085e2f8d3b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateDropTransaction_receipt$data = {
  readonly transactionFee: {
    readonly symbol: string;
    readonly unit: string;
    readonly usd: string;
  };
  readonly " $fragmentType": "CreateDropTransaction_receipt";
};
export type CreateDropTransaction_receipt$key = {
  readonly " $data"?: CreateDropTransaction_receipt$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreateDropTransaction_receipt">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreateDropTransaction_receipt",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PriceType",
      "kind": "LinkedField",
      "name": "transactionFee",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "symbol",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "usd",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TransactionReceiptType",
  "abstractKey": null
};

(node as any).hash = "0b4400788b03f26236787b518b24793c";

export default node;
